module.exports = __webpack_public_path__ + "static/media/RecomendaSalvador.39180eca.jpg";